import AutoScroll from "../../components/autoscrollcontents/AutoScroll";
import Downloader from "../../components/pdf_downloader/Downloader"
export default function Mcsppsa(){
    return(
            <AutoScroll heading={"MCPPSSA Act 2017 & Rule 2019"} contents={data}/>
    )
}

const data=[
    <Downloader url={"pdf/rules/Social_Audit_Rules_2019.pdf"} name={" The Meghalaya Community Participation and Public Services Social Audit Rules, 2019 "}/>,
    <Downloader url={"pdf/rules/Social_Audit_Act_2017.pdf"} name={" The Meghalaya Community Participation and Public Services Social Audit Act, 2017 "}/>
]